import cloud from 'assets/image/icons/svg/icons/cloud.svg'
import computer from 'assets/image/icons/svg/icons/computer.svg'
import warning from 'assets/image/icons/svg/icons/warning.svg'

import './style.scss'

import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { workspaceApi } from 'features/workspace'

const AutomationMode = () => {
	const {
		data: autoMode,
		isLoading,
		isSuccess
	} = workspaceApi.useAutomationModeQuery()

	if (isLoading) {
		return <FullLoader size={30} />
	}
	if (!isSuccess) {
		return null
	}

	const {
		city_name: city,
		country_code: countryCode,
		ip_address: ip,
		is_cloud: isCloud
	} = autoMode
	return (
		<div className='auto-mode-wrapper'>
			<div className='auto-mode-main'>
				{isCloud ? (
					<>
						<p className='auto-mode-info'>
							Processing:{' '}
							<span className='auto-mode-text'>
								{' '}
								<img alt='cloud' src={cloud} /> In cloud
							</span>
						</p>
						<p className='auto-mode-info'>
							IP Address: <span className='auto-mode-text'> {ip}</span>
						</p>
						<p className='auto-mode-info'>
							Location:{' '}
							<span className='auto-mode-text'>{`${city}, ${countryCode}`}</span>
						</p>
					</>
				) : (
					<p className='auto-mode-info'>
						Processing:{' '}
						<span className='auto-mode-text'>
							{' '}
							<img alt='computer' src={computer} /> locally on your PC{' '}
						</span>
					</p>
				)}
			</div>
			<div className='auto-mode-warning'>
				<img alt='warning' src={warning} />
				{isCloud ? (
					<div>
						<p>
							Snaily.io operates LinkedIn automation using cloud servers and
							assigns a dedicated IP address for the process. Through the
							snaily.io extension, all manual actions performed on LinkedIn are
							seamlessly executed using the same allocated IP address.
							<br />
							<br />
							This ensures consistency and reliability in your LinkedIn
							activities while maintaining anonymity and security.
						</p>
					</div>
				) : (
					<div>
						<p>
							Snaily.io operates LinkedIn automation from your PC, which is
							suitable if you manage a single LinkedIn account and can maintain
							your PC online during working hours.
							<br />
							<br /> However, this mode has a drawback: snaily.io does not
							function when your PC is turned off or if you lose internet
							connectivity.
							<br />
							<br />
							If you wish to keep automation running even when your PC is turned
							off or you experience an internet outage, you can transition
							snaily.io automation to the cloud. This option is available for{' '}
							<span className='strong'>PRO</span> or{' '}
							<span className='strong'>TEAM</span> plan subscribers.
						</p>
					</div>
				)}
			</div>
		</div>
	)
}

export default AutomationMode
